import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Box,
  Typography,
} from '@mui/material';

import PayoutInfoContainer from 'app/containers/payout/PayoutInfoContainer';

const PayoutInfoStep = ({ afterCancel, afterSuccess }) => {
  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h1">
          Payout Info
        </Typography>
        <PayoutInfoContainer
          onboardingVersion
          onCancel={afterCancel}
          afterSaveAction={afterSuccess}
        />
      </Box>
    </Container>
  );
};

PayoutInfoStep.propTypes = {
  afterCancel: PropTypes.func.isRequired,
  afterSuccess: PropTypes.func.isRequired,
};

export default PayoutInfoStep;
